import { getExampleNumber, parsePhoneNumber } from 'libphonenumber-js'
import examples from 'libphonenumber-js/mobile/examples'
import { CountryCode } from 'libphonenumber-js/types'

export const getPhonePlaceholder = (countryCode: CountryCode) =>
  getExampleNumber(countryCode || 'GB', examples)?.formatNational()

export const getCountryCode = (phoneNumber: string): string | undefined =>
  phoneNumber ? parsePhoneNumber(phoneNumber)?.country : 'GB'
